<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getInvoice } from '@/services/invoices/getInvoice'
import { getHistoricalByFactura } from '@/services/historical/getHistoricalByFactura'
import { getHistoricalByFacturaExcel } from '@/services/historical/getHistoricalByFacturaExcel'


export default {
  name: 'list-invoice-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 18,
      vuexnamespace: 'historicalInvoice',
      headerUrl: this.$route.meta?.recibida ? 'invoicesreceived/details' : 'invoicesissued/details',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('invoices.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  mounted () {
    this.breadcrumbs = [
      {
        url: this.esRecibida ? 'invoicesreceived' : 'invoicesissued',
        name: this.esRecibida ? i18n.t('invoices.received_header') : i18n.t('invoices.issued_header')
      },
      {
        routeCallback: this.stateRouteCallback,
        dataCallback: this.dataCallback,
        getter: 'app/headerBreadCrumb',
        setter: 'app/setheaderBreadCrumb',
      },
      {
        routeCallback: this.numRouteCallback,
        dataCallback: this.dataCallback,
      },
    ]
  },
  computed: {
    esRecibida: function () {
      return !!(this.$route.meta && this.$route.meta.recibida)
    },
    invoiceType: function () { 
      return this.esRecibida ? 'received' : 'issued' 
    },
    idEstado: function () {
      return this.$route.params.type
    },
    tiposEstados: function () {
      if (this.esRecibida) {
        return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
      }
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    nombreEstado: function () {
      return this.tiposEstados.find(x => x.id === this.idEstado)?.Nombre || this.idEstado
    },
  },
  methods: {
    getParamsAux: function (data) {
      return {
        idFacturae: this.$route.params.idFacturae,
        idInvoice: this.$route.params.idInvoice,
      }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getInvoice(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByFacturaExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByFactura(payload, params)
    },
    stateRouteCallback: function (data, elthis, breadcrumb) {
      return { path: `/invoices${this.invoiceType}/${data.idEstado}`, name: data.NombreEstado }
    },
    dataCallback: function (entity, elthis, breadcrumb) {
      const NombreEstado = this.tiposEstados.find(x => x.id === entity.idEstado)?.Nombre ?? entity.Estado
      return { NumFactura: entity.NumFactura, idEstado: entity.idEstado, NombreEstado }
    },
    numRouteCallback: function (data, elthis, breadcrumb) {
      return { path: '', name: elthis.truncate(data.NumFactura, 30, false) }
    },
  }
}
</script>

<style lang="scss" scoped></style>
